import gql from 'graphql-tag'

export const GET_BASIC_USER_INFO = gql`
  query getMe {
    user: getMe {
      id
      firstName
      lastName
      vipType
      email
      watchdogs {
        id
        items {
          id
          variantId
        }
      }
      pricingGroup
      clubs {
        id
        label
        status
      }
      partnerId
      notifications {
        allowNewsletterEmail
      }
    }
  }
`

export const GET_VIP_USER_INFO = gql`
  query getMyVipDiscountLimit {
    user: getMe {
      id
      vipDiscountLimit {
        current
        isReached
        max
        documentId
        limitsRenewal
      }
      vipType
    }
  }
`

export const GET_PAYMENT_CARDS = gql`
  query getPaymentCards {
    cards: getPaymentCards {
      items {
        id
        name
        longMaskedCard
        shortMaskedCard
        provider
        isActive
        isDefault
      }
    }
  }
`

export const GET_EXTENDED_USER_INFO = gql`
  query getMeExtended {
    user: getMe {
      id
      firstName
      lastName
      email
      companyName
      cid
      tin
      phone
      vipType
      hasPassword
      clubs {
        label
      }
      partnerId
      billingAddresses {
        items {
          id
          street
          city
          zip
          firstName
          lastName
          isCompany
          companyName
          cid
          tin
          isVerified
          verificationStatus
        }
      }
      shippingAddresses {
        items {
          id
          street
          city
          zip
          firstName
          lastName
          isCompany
          companyName
          phone
        }
      }
      allowAdultContent
      notifications {
        allowNewsletterEmail
        allowNewsletterSms
      }
      consentList(all: true) {
        code
        isAllowed
      }
    }
  }
`
export const MUTATION_USER_UPDATE_SHIPPING_ADDRESS = gql`
  mutation updateShippingAddress($address: UpdateShippingAddressInput!) {
    updateShippingAddress(address: $address)
  }
`

export const MUTATION_USER_CREATE_SHIPPING_ADDRESS = gql`
  mutation createShippingAddress($address: CreateShippingAddressInput!) {
    createShippingAddress(address: $address) {
      id
      street
      city
      zip
      firstName
      lastName
      companyName
      phone
    }
  }
`

export const MUTATION_USER_DELETE_SHIPPING_ADDRESS = gql`
  mutation deleteShippingAddress($address: DeleteAddressInput!) {
    deleteShippingAddress(address: $address)
  }
`

export const MUTATION_USER_DELETE_PAYMENT_CARD = gql`
  mutation deletePaymentCard($id: ID!) {
    deletePaymentCard(id: $id)
  }
`

export const MUTATION_USER_CREATE_BILLING_ADDRESS = gql`
  mutation createBillingAddress($address: CreateBillingAddressInput!) {
    createBillingAddress(address: $address) {
      id
      street
      city
      zip
      firstName
      lastName
      companyName
      cid
      tin
    }
  }
`

export const MUTATION_USER_CREATE_BILLING_ADDRESS_FROM_VAT = gql`
  mutation createBillingAddressFromCompanyId(
    $input: CreateBillingAddressFromCompanyIdInput!
  ) {
    createBillingAddressFromCompanyId(input: $input) {
      statusCode
      message
      billingProfileId
    }
  }
`

export const MUTATION_USER_REQUEST_MANUAL_BILLING_ADDRESS_VERIFICATION = gql`
  mutation requestManualAddressVerification(
    $data: ManualAddressVerificationInput!
  ) {
    requestManualAddressVerification(data: $data)
  }
`

export const MUTATION_USER_UPDATE_BILLING_ADDRESS = gql`
  mutation updateBillingAddress($address: UpdateBillingAddressInput!) {
    updateBillingAddress(address: $address)
  }
`

export const MUTATION_USER_DELETE_BILLING_ADDRESS = gql`
  mutation deleteBillingAddress($address: DeleteAddressInput!) {
    deleteBillingAddress(address: $address)
  }
`

export const MUTATION_USER_UPDATE_ME = gql`
  mutation updateMe($customer: UpdateMeInput!) {
    updateMe(customer: $customer)
  }
`

export const MUTATION_CHANGE_PASSWORD = gql`
  mutation changePassword($data: ChangePasswordInput!) {
    changePassword(data: $data)
  }
`

export const MUTATION_CHANGE_EMAIL = gql`
  mutation changeEmail($data: ChangeEmailInput!) {
    initChangeEmail(data: $data)
  }
`

export const MUTATION_FINISH_CHANGE_EMAIL = gql`
  mutation finishChangeEmail($hash: String!) {
    finishChangeEmail(hash: $hash)
  }
`

export const MUTATION_INIT_ACCOUNT_DEACTIVATION = gql`
  mutation initAccountDeactivation {
    initAccountDeactivation
  }
`

export const MUTATION_FINISH_ACCOUNT_DEACTIVATION = gql`
  mutation finishAccountDeactivation($hash: String!) {
    finishAccountDeactivation(hash: $hash)
  }
`

export const MUTATION_RESET_PASSWORD_INIT = gql`
  mutation initResetPassword($data: InitResetPasswordInput!) {
    initResetPassword(data: $data)
  }
`

export const MUTATION_RESET_PASSWORD_FINISH = gql`
  mutation finishResetPassword($data: FinishResetPasswordInput!) {
    finishResetPassword(data: $data)
  }
`

export const MUTATION_CREATE_CUSTOMER_CONSENT = gql`
  mutation createCustomerConsent($consent: CreateCustomerConsentInput!) {
    createCustomerConsent(consent: $consent) {
      id
      firstName
      lastName
      consentList(all: true) {
        code
        isAllowed
      }
    }
  }
`

export const MUTATION_INIT_REGISTRATION = gql`
  mutation initRegistration($data: InitRegistrationInput!) {
    initRegistration(data: $data) {
      smartClubActivationFailed
    }
  }
`

export const MUTATION_CHECK_REGISTRATION_HASH = gql`
  mutation checkRegistrationHash($data: CheckRegistrationHashInput!) {
    checkRegistrationHash(data: $data) {
      email
    }
  }
`

export const MUTATION_FINISH_REGISTRATION = gql`
  mutation finishRegistration($data: FinishRegistrationInput!) {
    finishRegistration(data: $data)
  }
`

export const FINISH_REVIEW_EMAIL_DEACTIVATION = gql`
  mutation finishReviewEmailDeactivation($hash: String!) {
    finishReviewEmailDeactivation(hash: $hash)
  }
`
